import styled from 'styled-components/macro'
import { MENU, BREAK_ } from 'constants'

export const Menu = styled.div`
  position:fixed;
  z-index:10;
  top:0;
  left:0;
   /* Dynamic height based on safe area */
  height: calc(71px + env(safe-area-inset-top, 0px));

  /* Add padding so the logo never gets pushed down weirdly */
  padding-top: env(safe-area-inset-top, 0px);
  width:100%;
  background-color: ${ ({clr}) => clr.primary };
  color: ${ ({clr}) => clr.primary_text };
  display:flex;
  > span:nth-child(1) {
    /* border:1px solid blue; */
    display:flex;
    justify-content:flex-start;
    align-items:flex-start;
    max-width:120px;
  };
  > span:nth-of-type(2) {
    /* border:1px solid green; */
    /* flex:1; */
    display:flex;
    justify-content:center;
    align-items:flex-start;
  }

`

export const Gap = styled.div`
width:${({i}) => i}px;
`
export const Section = styled.div`
  display: flex;
  background-color: ${({ clr }) => `${clr?.buttons_text}bf`};
  color: ${({ clr, pin, showButton }) => ('#000')};

  height: 44px;
  border-radius: 8px;
  border: 1px solid ${({ clr, pin, showButton }) => ( `${clr?.buttons_text}`)};
  justify-content: center;
  align-items: center;
   padding: 0 10px;
  gap: 10px;
  line-height: 1;
  cursor: pointer;
  user-select: none;
  width: 185px;
`
export const Text = styled.div`
  white-space: nowrap;
  font-size: 18px;
  font-weight: 400px;
  color: ${({ clr, atUnit }) => atUnit ? `${clr?.primary_text_passive}` : `${clr?.primary_text_passive}`};
`;
export const BackBox = styled.div`
  gap: 5px;
  cursor: pointer;
  padding: 5px 15px;
  z-index: 5;
  align-items: center;
  display: flex;
  gap: 5px;
  user-select: none;
  ${BREAK_.md_dn} {
    position: fixed;
    top: 90px;
    left: 16px;
    padding: 0;
  }
`;

export const CarratLeft = styled.div`
  position: absolute;
  width: 30px;
  height: 30px;
  left: 0px;
  bottom: ${({bottom}) => bottom ? bottom : '-30px'};
  background: ${({bgColor}) => bgColor ? bgColor : '#EFEFEF' };
  // clip-path: polygon(36% 0, 26% 4%, 15% 11%, 6% 22%, 0 32%, 0 0);
  clip-path: polygon(0.25% 0%, 50.25% 0%, 37.64% 5.74%, 31.8% 9.44%, 25.96% 13.13%, 19.84% 18.92%, 15.16% 25.92%, 9.57% 34.28%, 5.21% 41.64%, 0.25% 50%);
  z-index: 5;
`

export const CarratRight = styled.div`
  position: absolute;
  width: 30px;
  height: 30px;
  right: 0;
  bottom: ${({bottom}) => bottom ? bottom : '-30px'};
  transform: rotateY(180deg);
  background: ${({bgColor}) => bgColor ? bgColor : '#EFEFEF' };
  clip-path: polygon(0.25% 0%, 50.25% 0%, 37.64% 5.74%, 31.8% 9.44%, 25.96% 13.13%, 19.84% 18.92%, 15.16% 25.92%, 9.57% 34.28%, 5.21% 41.64%, 0.25% 50%);
   z-index: 5;
`
